import React from "react";
import { FiSearch } from "react-icons/fi";

export default function RechercheEmptyState({ query }) {
  return (
    <div className="rounded-[2rem] border border-dashed border-slate-300 bg-white px-6 py-12 text-center shadow-sm dark:border-slate-700 dark:bg-slate-950">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-3xl bg-slate-100 text-slate-500 dark:bg-slate-900 dark:text-slate-300">
        <FiSearch className="h-7 w-7" />
      </div>

      <h2 className="mt-5 text-xl font-bold text-slate-950 dark:text-white">
        Aucun résultat trouvé
      </h2>

      <p className="mx-auto mt-2 max-w-xl text-sm leading-7 text-slate-600 dark:text-slate-300">
        Aucun contenu ne correspond à « <strong>{query}</strong> ». Essayez avec
        un mot-clé plus court ou plus général.
      </p>
    </div>
  );
}